export const CONFIRM_DELETE_MEMO_BOOKING_MESSAGE = "予約メモを削除します。よろしいですか？";
export const ERROR_LOADING_MESSAGE = "メッセージが読み込めないため、再度試してください。";
